// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__38vtO","overflowing":"ReadFullNote_overflowing__3pIfj"};